module.exports = {"540327100":"旺达镇","540327101":"田妥镇","540327102":"扎玉镇","540327200":"东坝乡","540327201":"中林卡乡","540327202":"美玉乡","540327203":"下林卡乡","540327204":"碧土乡","540327205":"仁果乡","540327206":"绕金乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540327.json
// module id = 2516
// module chunks = 0